import CardStack from '@shared/components/core/card/CardStack';
import { useTranslation } from 'react-i18next';
import OrgLinks from '../OrgLinks';

export interface IManagedOrgCardProps {
    orgId: string;
}

export default function ManagedOrgCard({ orgId }: IManagedOrgCardProps) {
    const { t } = useTranslation();

    if (!orgId) return null;
    return (
        <CardStack
            name="orgCompany"
            title={t('common:organization.managed.titlePlural')}
            description={t('common:organization.managed.description')}>
            <OrgLinks organizationId={orgId} variant={'orgManagedOrgs'} />
        </CardStack>
    );
}
